var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1336,
    height: 755,
    viewBox: "0 0 1336 755",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1335.2 1.60424L1333.6 0L1332 1.60425L1333.6 3.20849L1335.2 1.60424Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M505.372 10.6367L502.79 13.8227C502.464 14.2254 502.464 14.8019 502.79 15.2045L505.372 18.3905L502.19 15.8053C501.788 15.4786 501.212 15.4786 500.81 15.8053L497.628 18.3905L500.21 15.2045C500.536 14.8019 500.536 14.2254 500.21 13.8227L497.628 10.6367L500.81 13.2219C501.212 13.5487 501.788 13.5487 502.19 13.2219L505.372 10.6367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M513 14.5138L502.042 15.0566L501.5 26.0276L500.958 15.0566L490 14.5138L500.958 13.971L501.5 3L502.042 13.971L513 14.5138Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M737.144 94.6758L735.325 96.9196C735.096 97.2032 735.096 97.6093 735.325 97.8929L737.144 100.137L734.903 98.316C734.62 98.0858 734.214 98.0858 733.931 98.316L731.69 100.137L733.508 97.8929C733.738 97.6093 733.738 97.2032 733.508 96.9196L731.69 94.6758L733.931 96.4965C734.214 96.7266 734.62 96.7266 734.903 96.4965L737.144 94.6758Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M742.516 97.4059L734.799 97.7882L734.417 105.515L734.035 97.7882L726.317 97.4059L734.035 97.0237L734.417 89.2969L734.799 97.0237L742.516 97.4059Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75061 457.879L2.87524 455L-0.000115003 457.879L2.87525 460.758L5.75061 457.879Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.241 411.734L205.365 408.855L202.49 411.734L205.365 414.613L208.241 411.734Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M748.691 109.848L746.846 108L745 109.848L746.846 111.696L748.691 109.848Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.751 751.879L231.875 749L229 751.879L231.876 754.758L234.751 751.879Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M594.209 548.562L591.99 551.3C591.71 551.646 591.71 552.141 591.99 552.487L594.209 555.225L591.474 553.004C591.129 552.723 590.634 552.723 590.288 553.004L587.554 555.225L589.773 552.487C590.053 552.141 590.053 551.646 589.773 551.3L587.554 548.562L590.288 550.784C590.634 551.065 591.129 551.065 591.474 550.784L594.209 548.562Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M600.763 551.893L591.347 552.36L590.881 561.787L590.416 552.36L581 551.893L590.416 551.427L590.881 542L591.347 551.427L600.763 551.893Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.744 489.812L189.763 493.49C189.386 493.955 189.386 494.62 189.763 495.085L192.744 498.762L189.071 495.778C188.606 495.401 187.942 495.401 187.477 495.778L183.804 498.762L186.785 495.085C187.162 494.62 187.162 493.955 186.785 493.49L183.804 489.812L187.477 492.796C187.942 493.174 188.606 493.174 189.071 492.796L192.744 489.812Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.548 494.29L188.9 494.916L188.274 507.58L187.648 494.916L175 494.29L187.648 493.663L188.274 481L188.9 493.663L201.548 494.29Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.37 406L1071.91 409.033C1071.6 409.417 1071.6 409.965 1071.91 410.349L1074.37 413.382L1071.34 410.921C1070.96 410.61 1070.41 410.61 1070.03 410.921L1067 413.382L1069.46 410.349C1069.77 409.965 1069.77 409.417 1069.46 409.033L1067 406L1070.03 408.461C1070.41 408.772 1070.96 408.772 1071.34 408.461L1074.37 406Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.9 409.962L1071.46 410.479L1070.95 420.924L1070.43 410.479L1060 409.962L1070.43 409.445L1070.95 399L1071.46 409.445L1081.9 409.962Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.37 537.141L1083.96 540.12C1083.66 540.496 1083.66 541.036 1083.96 541.412L1086.37 544.391L1083.4 541.974C1083.02 541.668 1082.48 541.668 1082.11 541.974L1079.13 544.391L1081.55 541.412C1081.85 541.036 1081.85 540.496 1081.55 540.12L1079.13 537.141L1082.11 539.558C1082.48 539.864 1083.02 539.864 1083.4 539.558L1086.37 537.141Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.51 540.767L1083.26 541.274L1082.75 551.534L1082.25 541.274L1072 540.767L1082.25 540.259L1082.75 530L1083.26 540.259L1093.51 540.767Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M368.608 70.7639L366 68.1523L363.392 70.7639L366 73.3754L368.608 70.7639Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M366 57.7188L366.426 68.5808H365.574L366 57.7188Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M366 83.7527L366.426 72.8906H365.574L366 83.7527Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M379 70.731L368.151 70.3047V71.1573L379 70.731Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M353 70.731L363.849 70.3047V71.1573L353 70.731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.ff79cd1e48dfe3df0a49c3c2d419d069.svg";
export { ForwardRef as ReactComponent };